<template>
    <v-card>
        <v-tabs class="text-green" v-model="tab" align-tabs="center" stacked>
            <v-tab value="tab-1">
                <v-icon>mdi-safety-goggles</v-icon>
                RV
            </v-tab>

            <v-tab value="tab-2">
                <v-icon>mdi-cube-scan</v-icon>
                AR

            </v-tab>

            <v-tab value="tab-3">
                <v-icon>mdi-pencil-ruler</v-icon>
                Visuales
            </v-tab>
            <v-tab value="tab-4">
                <v-icon>mdi-card-account-mail-outline</v-icon>
                Email
            </v-tab>
        </v-tabs>

        <v-window v-model="tab">
            <v-window-item value="tab-1">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/ar.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>VIRTUAL REALITY</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Impulsa tu marca con experiencias de realidad virtual. Ofrecemos soluciones innovadoras
                        que sumergen a tu audiencia en mundos virtuales creados a medida, desde recorridos interactivos
                        hasta simulaciones de productos. Aprovecha el poder de la VR para contar tu historia de manera
                        impactante y memorable.
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="tab-2">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/rv.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>AUGMENTED REALITY</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Eleva tu marca en Instagram, Facebook y TikTok, con nuestros servicios de realidad aumentada.
                        Creamos filtros
                        interactivos y experiencias inmersivas que capturan la atención de tu audiencia, mejorando el
                        engagement y ofreciendo una forma innovadora de interactuar con tus seguidores. Haz que tu marca
                        destaque.
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="tab-3">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/design.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>GRAPHIC DESIGN</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Potencia tu imagen con nuestro servicio de diseño gráfico: desde logotipos y banners
                        hasta
                        material POP. Creamos soluciones visuales impactantes que capturan la esencia de tu
                        marca,
                        mejorando tu presencia y comunicación visual. Transformamos tus ideas en diseños
                        memorables que
                        conectan con tu audiencia.
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="tab-4">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/email.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>EMAIL MARKETING</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Maximiza tus campañas con nuestro servicio de email marketing. Diseñamos y enviamos
                        correos
                        electrónicos personalizados que hablan directo a tu audiencia, mejorando la fidelización
                        y
                        conversión. Con estrategias basadas en datos, aseguramos que tu mensaje llegue al
                        momento y
                        lugar correctos.
                    </v-card-text>
                </v-card>
            </v-window-item>
        </v-window>
    </v-card>
</template>
<script>
export default {
    name: "otherServices",
    data() {
        return {
            tab: null,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        }
    },
}
</script>